import Contact from "@/components/feature/Contact";

export default function ContactPage() {
  return (
    <>
      {/* Aldy Receptionist Hero Section */}
      <section className="relative py-20 md:py-28 bg-primary-700 overflow-hidden">
        {/* Background pattern image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10"
          style={{
            backgroundImage:
              "url(/images/contact-hero.webp)",
          }}
        />
        <div className="relative z-10 px-4 md:px-6 lg:px-10">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
              <div>
                <span className="text-accent-400 text-xs md:text-sm font-semibold tracking-[0.3em] uppercase mb-6 block">
                  24/7 Dispatch Center
                </span>
                <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
                  Speak With <span className="text-accent-400">Our Team</span>
                </h1>
                <p className="text-background-50/80 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
                  Our dedicated dispatch team is available around the clock to answer your calls, 
                  coordinate rapid officer deployment, and ensure your security concerns are 
                  addressed immediately. No automated menus — just real people, real fast.
                </p>
                <div className="grid grid-cols-2 gap-4 mb-8">
                  <div className="bg-background-50/10 rounded-lg p-4 border border-background-50/20">
                    <div className="font-heading text-2xl font-bold text-accent-400 mb-1">24/7</div>
                    <div className="text-background-50/60 text-xs">Live Dispatch</div>
                  </div>
                  <div className="bg-background-50/10 rounded-lg p-4 border border-background-50/20">
                    <div className="font-heading text-2xl font-bold text-accent-400 mb-1">&lt; 5 min</div>
                    <div className="text-background-50/60 text-xs">Officer Dispatch</div>
                  </div>
                  <div className="bg-background-50/10 rounded-lg p-4 border border-background-50/20">
                    <div className="font-heading text-2xl font-bold text-accent-400 mb-1">Bilingual</div>
                    <div className="text-background-50/60 text-xs">English &amp; Spanish</div>
                  </div>
                  <div className="bg-background-50/10 rounded-lg p-4 border border-background-50/20">
                    <div className="font-heading text-2xl font-bold text-accent-400 mb-1">30+</div>
                    <div className="text-background-50/60 text-xs">Dispatchers On Staff</div>
                  </div>
                </div>
                <a
                  href="tel:+15626060053"
                  className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold px-8 py-4 rounded-md transition-all duration-300 whitespace-nowrap text-sm"
                >
                  <i className="ri-phone-line" />
                  Call (562) 606-0053
                </a>
              </div>
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="/images/contact-us.webp"
                  alt="Askari Security dispatch receptionist"
                  className="w-full h-[350px] md:h-[450px] object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form & Info */}
      <Contact />
    </>
  );
}